import { createUseStyles } from 'react-jss'

import { MQ, COLOR } from 'utils/constants'

export const useStyles = createUseStyles({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    [MQ.DESKTOP]: {
      width: '52%',
      flexDirection: 'column-reverse',
      justifyContent: 'flex-end',
    },
  },
  imageWrapper: {
    position: 'relative',
  },
  image: {
    maxHeight: 262,
    [MQ.TABLET_LARGE]: {
      maxHeight: 350,
    },
    [MQ.DESKTOP]: {
      maxHeight: 'unset',
    },
  },
  filter: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'rgba(117, 132, 77, 0.8)',
    [MQ.DESKTOP]: {
      display: 'none',
    },
  },
  bodyTitle: {
    color: COLOR.LIGHT_GREEN,
    textTransform: 'uppercase',
    marginBottom: 35,
  },
  title: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    color: COLOR.WHITE,
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
    width: '80%',
    textAlign: 'center',
    [MQ.DESKTOP]: {
      display: 'none',
    },
  },
  textBlock: {
    width: '80%',
    margin: [35, 'auto', 0],
    [MQ.TABLET]: {
      maxWidth: 522,
      margin: [50, 'auto', 0],
    },
    [MQ.DESKTOP]: {
      margin: [0, 0, 0, '22%'],
      maxWidth: 'unset',
      width: '75%',
      transform: 'translateY(62px)',
    },
  },
  subtitle: {
    fontWeight: 600,
    lineHeight: 1.6,
  },
  linkColumn: {
    display: 'flex',
    flexDirection: 'column',
  },
  label: {
    color: COLOR.LIGHT_GREEN,
    marginBottom: 5,
  },
  link: {
    color: COLOR.DARK_GREEN,
    textDecoration: 'none',
    '& span': {
      fontWeight: 600,
    },
  },
  desktopLinks: {
    display: 'flex',
    width: '46%',
    justifyContent: 'space-between',
    margin: [90, 0, 100, '22%'],
  },
})
